export default __webpack_public_path__ + "static/media/dieppe26.2cd0a9cb.jpg";